"use strict"
define('stores/resource-buncees',[
    "stores/store",
    "actions/shared-entities",
    "constants/actiontypes",
    "xregexp"
],
function(StoreBase, Action, Constants, XRegExp) {
    Store.prototype = new StoreBase();
    Store.constructor = Store;

    function Store(params) {
        // Call parent constructor
        StoreBase.call(this, params);

        this.buncees = {};

        this.registerDispatchListener(function (action) {
            switch (action.actionType) {
                case Constants.ADD_RESOURCE_BUNCEES:
                    if (Array.isArray(action.data)) {
                        _.each(action.data, function (data, index, list) {
                            this.addBuncees(data);
                        }, this);
                    } else {
                        this.addBuncees(action.data);
                    }
                    this.event.emit("change");
                    break;
            }
        }.bind(this));

        this.action = new Action();
    }

    Store.prototype.addBuncees = function (data) {
        if (this.buncees[data.guid.toLowerCase()]) {
            delete this.buncees[data.guid.toLowerCase()];
        }

        // Make GUIDs as lower case
        data.guid = data.guid.toLowerCase();

        this.buncees[data.guid.toLowerCase()] = data;
    };

    Store.prototype.getAll = function (filterOptions, sortOptions) {
        var resources = [];
        resources = _.map(this.buncees, function (item) { return item; });

        if (filterOptions) {
            if (filterOptions.keyword) {
                // Trim all spaces from beginning and ending
                var keyword = filterOptions.keyword.trim();

                // Make a regular expression to allow all characters, numerics, and spaces
                var allowCharacterSets = XRegExp("[^\\pL\\s\\d\\w-]+", "g");

                // Replace all special characters as nothing and space as OR("|")
                keyword = XRegExp.replace(keyword, allowCharacterSets, "");
                keyword = keyword.trim().replace(/\s+/g, "|");

                // Make a regular expression to search with keyword
                var regExp = new RegExp(keyword, "i");

                resources = resources.filter(function(item) {
                    return regExp.test(item.title) || regExp.test(item.owner_first_name) || regExp.test(item.owner_last_name);
                });
            }
        }

        if (sortOptions) {
            var isNameSort = sortOptions.sortColumn === "name";
            var isDateSort = sortOptions.sortColumn === "created_at";
            resources.sort(function (a, b) {
                var aVal;
                var bVal;
                var result;

                if (isNameSort) {
                    aVal = a.owner_first_name.toLowerCase() + a.owner_last_name.toLowerCase();
                    var bVal = b.owner_first_name.toLowerCase() + b.owner_last_name.toLowerCase();
                } else {
                    aVal = a[sortOptions.sortColumn];
                    bVal = b[sortOptions.sortColumn];
                }
                
                if (isDateSort) {
                    var result = aVal <= bVal;
                    if (sortOptions.sortAsc)
                        result = !result;
                } else {
                    var result = aVal.localeCompare(bVal);
                    if (sortOptions.sortAsc)
                        result *= -1;
                }

                return result;
            });
        }
        return resources;
    };

    return Store;
});
